import { render } from "./Cookies.vue?vue&type=template&id=ec4179f4&scoped=true"
import script from "./Cookies.vue?vue&type=script&lang=js"
export * from "./Cookies.vue?vue&type=script&lang=js"

import "./Cookies.vue?vue&type=style&index=0&id=ec4179f4&lang=scss"
import "./Cookies.vue?vue&type=style&index=1&id=ec4179f4&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3298490778/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec4179f4"]])

export default __exports__